import React from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {RequestError} from '../../../network/response/RequestError'
import {RequestItemError} from '../../../network/response/RequestItemError'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'

interface Props {
    requestError: Nullable<RequestError>
    requestItemErrors: Nullable<RequestItemError[]>
}

const RRFFErrorInformation: React.FC<Props> = props => {
    if (props.requestError === null) {
        return null
    }
    const itemErrors = props.requestItemErrors || []
    const detail: string =
        props.requestError.message +
        ((itemErrors.length > 0) ? '\n' + itemErrors.map(item => item.message).join('\n') : '')

    return <>
        <BlockSpacer height={'15px'}/>
        <ErrorArea>
            <ErrorTitle>
                {props.requestError.title}
            </ErrorTitle>
            <ErrorDetail>
                {detail}
            </ErrorDetail>
        </ErrorArea>
    </>
}

RRFFErrorInformation.displayName = 'RRFFErrorInformation'
export default RRFFErrorInformation

const ErrorArea = styled.div`
  background-color: rgba(215, 55, 74, 0.05);
  padding: 10px;
`

const ErrorTitle = styled.div`
  color: ${Colors.Alert};
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Bold};
`

const ErrorDetail = styled(PreformattedDiv)`
  color: ${Colors.AccentDark};
  font-size: ${FontSize.Small};
`
